import OrbswayLoader from "../../assets/Loader/OrbswayLoader.json"
import Lottie from '@lottielab/lottie-player/react';


export const OrbswayLoaderComponent = () => {
    return (
        <div className="relative">
            <Lottie src={OrbswayLoader} autoplay />
            <div className="w-[800px] bg-white h-40 absolute right-0 bottom-0" />
        </div>
    )

}
